// extracted by mini-css-extract-plugin
export default {"card":"change_request_view_page-module___card___c251ba04"};